import { Component, Input } from '@angular/core';
import { MenuItem } from './model/navbar.model';
import {ROUTE_ASSET_LIB_COMPS, ROUTE_ASSETS_ICON} from 'src/app/shared/constants/route-paths';
import { PNG } from 'src/app/shared/constants/constants';


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent  {
    @Input() public items!: string[] ;

    public pageTitle ?: string;
    public pageName = '';
    public pageIcon ?: string;
    public MenuItems: Array < MenuItem > = [];

    constructor() {}


    /**
     *
     * this methos will return the url for icons
     * @param {string} icon
     * @return {*}  {string}
     * @memberof NavbarComponent
     */
    public getUrl(icon: any): string {
        return  ROUTE_ASSET_LIB_COMPS + ROUTE_ASSETS_ICON + icon + PNG;
    }
}
